<template>
     <div class="p20" v-loading.body="loading">
        <!-- 头部按钮部分 start -->
        <div class="el-row ly-bill-title">
            <el-col :span="12">
                <h1 style="padding-top:5px;">修改胎号记录</h1>
            </el-col>
            <el-col :span="12" class="tr">
                <el-button type="primary" @click="submit" size="small" :loading="submitLoad">
                    <i class="fa fa-save" v-if="!submitLoad"></i>&nbsp;提交
                </el-button>
                <ly-router-button size="small">
                    <i class="fa fa-chevron-left"></i>&nbsp;返回
                </ly-router-button>
            </el-col>
        </div>
        <!-- 头部按钮部分 end -->
        <!-- 商品选择组件 start -->
        <el-card class="box-card mt15" ref="productCard" v-if="!loading"> 
            <ly-product-table 
                ref="productTable"
                v-model="productList"
                :is-add="false"
                :is-delete="false"
                :thead-config="productConfig">
            </ly-product-table>
        </el-card>
        <!-- 商品选择组件 end -->
    </div>
</template>
<script>
    /**
     * 胎号管理的修改页面
     * @author zjs
     * @time 2017-09-18
     */
    import AddProductConfig from './edit-product'
    import LyProductTable from '@c/product-table'
    import LyRouterButton from '@c/router-button'
    import AddRulesConfig from './rules'
    export default {
        mixins: [
            AddProductConfig,
            AddRulesConfig
        ],
        components: {
            LyProductTable,
            LyRouterButton
        },
        data () {
            return {
                loading: true,
                submitLoad: false, // 提交按钮的状态标识
                infoId: 0,
                productList: [] // 胎号列表
            }
        },
        created () {
            this.init()
        },
        watch: {
            '$route' (to, from) {
                // 路由变化时，更新配置
                if (to.name === 'ChecktaiAdd') {
                    this.init()
                }
            }
        },
        methods: {
            init () {
                // 获取详情的ID
                this.infoId = this.$route.params.id
                if (this.infoId) {
                    this.queryEditData()
                } else {
                    this.$message({
                        message: '无ID',
                        type: 'warning'
                    })
                }
            },
            /**
             * 获取要修改的数据
             */
            queryEditData () {
                this.$api.queryArr(['api/taihaoGL', 'edit'], null, [this.infoId]).then((rs) => {
                    this.productList.push(rs)
                    // 取消加载
                    setTimeout(() => {
                        this.loading = false
                    }, 100)
                }).catch((error) => {
                    // 取消加载
                    this.loading = false
                    this.$message({
                        message: error,
                        type: 'warning'
                    })
                })
            },
            submit () {
                if (this.productList && this.productList.length > 0) {
                    // 货品验证
                    let productMsg = this.validateProduct(this.productList)
                    // 货品验证不通过的情况
                    if (productMsg.length > 0) {
                        this.$alert(productMsg, '货品录入提示', {
                            confirmButtonText: '确定'
                        })
                    } else {
                        this.submitLoad = true
                        // 提交数据
                        this.$api.save('api/taihaoGL/' + this.infoId, this.productList[0]).then((rs) => {
                            this.$alert('数据提交成功', '新增', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    this.submitLoad = false
                                    // 跳转到详情页面
                                    this.$router.push('/bill/checktai/list')
                                }
                            })
                        }).catch((error) => {
                            this.submitLoad = false
                            this.$message({
                                message: error,
                                type: 'warning'
                            })
                        })
                    }
                } else {
                    this.$message({
                        message: '请选择货品',
                        type: 'warning'
                    })
                }
            }
        }
    }
</script>